// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const CreatePortfolioModalContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-createportfoliomodalcontainer" */ "./CreatePortfolioModalContainer")).then((bundle)=>{
        return {
            default: bundle.CreatePortfolioModalContainer
        };
    });
export const LazyCreatePortfolioModalContainer = /*#__PURE__*/ lazy(CreatePortfolioModalContainerLazyLoader);
